import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import businessCategoryConfig from '../../../../business-category-config';
import { IconClose } from '../../../../components';

import css from './../AutocompleteListing.css';

const LastSearches = ({
  handleClearClick,
  filteredLastSearches,
  categories,
  handleLastSearchClick,
  highlightedSuggestionIndex,
  predictionsClasses,
}) => {
  return (
    <div className={css.container}>
      <div className={css.subheadingContainer}>
        <p className={css.subheading}>
          <FormattedMessage id={'MainFilters.latestSearch'} />
        </p>
        <button className={css.clearBtn} onClick={handleClearClick} id="clearButton">
          <FormattedMessage id={'MainFilters.clear'} />
          <IconClose className={css.icon} />
        </button>
      </div>
      <ul className={predictionsClasses}>
        {filteredLastSearches.map((item, index) => {
          const { keyword, category, subcategory, location } = item;
          const categoryLabel = categories.find(option => option.key === category)?.label;
          const subcategoryLabel = businessCategoryConfig.find(({ key }) => key === subcategory)
            ?.label;
          const label = subcategoryLabel || categoryLabel;
          return (
            <li
              key={index}
              onClick={() => handleLastSearchClick(item)}
              className={classNames(css.searchWrapper, css.listItem, {
                [css.highlightedSuggestion]: index === highlightedSuggestionIndex,
              })}
            >
              <div>
                <span className={css.text}>{keyword}</span>
                {label && <p className={css.subtext}>{label}</p>}
              </div>
              <p className={css.subtext}>{location}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LastSearches;
